import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { Box, IconButton, TextField, Typography } from '@mui/material'
import React from 'react'

import { ReactComponent as AlertCircle } from '../../icons/alert-circle.svg'

interface IProps {
  title: string
  description: React.ReactNode
  isEditable: boolean
  value: number
  setValue: (value: number) => void
  hasValidValue: boolean
  errorMessage: string
  handleDecrement: () => void
  handleIncrement: () => void
  hasEntityDowngrade?: boolean
  entityDowngradeMessage?: React.ReactNode
}

function NumberOfEntityBox(props: IProps) {
  const {
    title,
    description,
    value,
    isEditable,
    setValue,
    hasValidValue,
    errorMessage,
    handleDecrement,
    handleIncrement,
    hasEntityDowngrade,
    entityDowngradeMessage,
  } = props

  return (
    <Box
      sx={{
        marginBottom: 2,
        paddingY: 2,
        paddingX: 3,
        border: '1px solid',
        borderColor: 'grey.200',
        borderRadius: '8px',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ flexGrow: 1, maxWidth: '364px' }}>
          <Typography variant="subtitle1" color="grey.700" fontWeight={500} mb={0.25}>
            {title}
          </Typography>

          <Typography variant="body2" color="grey.500" sx={{ '& span': { color: 'primary.700', fontWeight: 500 } }}>
            {description}
          </Typography>
        </Box>

        {isEditable && (
          <Box display="flex" alignItems="center" marginLeft="auto">
            <IconButton
              disabled={value === 0}
              onClick={handleDecrement}
              aria-label="Remove"
              sx={{ marginRight: 0.5, padding: 1 }}
            >
              <RemoveIcon sx={{ width: '20px', height: '20px', fill: 'grey.500' }} />
            </IconButton>

            <TextField
              value={value}
              onChange={(e) => setValue(Number(e.target.value))}
              type="number"
              variant="outlined"
              sx={{
                '& .MuiInputBase-root': {
                  width: '38px',
                  height: '38px',
                },
              }}
            />

            <IconButton onClick={handleIncrement} aria-label="Add" sx={{ marginLeft: 0.5, padding: 1 }}>
              <AddIcon sx={{ width: '20px', height: '20px', fill: 'grey.500' }} />
            </IconButton>
          </Box>
        )}
      </Box>

      {hasEntityDowngrade && hasValidValue && entityDowngradeMessage}

      {!hasValidValue && (
        <Box sx={{ display: 'flex', alignItems: 'center', marginTop: 1 }}>
          <AlertCircle />

          <Typography variant="body2" color="error.700" ml={1}>
            {errorMessage}
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default NumberOfEntityBox
